import Enumerator from '../global/Enumerator';

export const ticketSharedWithClientProfileTypes = [
  'details',
  'employments',
  'income',
  'real_estate',
  'other_assets',
  'liabilities',
  'expenses',
  'advisors',
  'needs_and_objectives',
  'product_requirements',
  'documents'
];

export class TicketSharedWithClientProfileType extends Enumerator {}

TicketSharedWithClientProfileType.initEnum({
  details: {
    get title() {
      return 'Details';
    }
  },
  employments: {
    get title() {
      return 'Employment';
    }
  },
  income: {
    get title() {
      return 'Income';
    }
  },
  real_estate: {
    get title() {
      return 'Real estate';
    }
  },
  other_assets: {
    get title() {
      return 'Other assets';
    }
  },
  liabilities: {
    get title() {
      return 'Liabilities';
    }
  },
  expenses: {
    get title() {
      return 'Expenses';
    }
  },
  advisors: {
    get title() {
      return 'Advisors';
    }
  },
  needs_and_objectives: {
    get title() {
      return 'Needs and objectives';
    }
  },
  product_requirements: {
    get title() {
      return 'Product requirements';
    }
  },
  documents: {
    get title() {
      return 'Documents';
    }
  }
});

export default {
  TicketSharedWithClientProfileType
};
